<template>
  <div class="single-answer">
    <div class="question-title" id='contentItem' ref='contentItem'>Question {{question.questionNo}}</div>
    <div class="question-part">
      <div class="que-row">
        <div class="que-col-1">&nbsp;</div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor
			:read-only="isEditable"
              :editorUrl="editorURL"
              v-model="question.question_text"
              :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false}"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>

    <div class="col-part">
      <div class="right-que-part">
        <div class="question-title">Column I</div>
        <div v-for="(opt,qindex) in question.options_abc" :key="qindex" class="que-row">
          <div class="que-col-1">
            <span class="opction-text">{{opt.index}}</span>
          </div>
          <div class="que-col-2">
            <div class="ck-editor">
              <ckeditor
			  :read-only="isEditable"
                :editorUrl="editorURL"
                v-model="opt.option_text"
                :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
              ></ckeditor>
            </div>
          </div>
        </div>

        <div class="que-row add-sl-opction">
          <div class="que-col-1">&nbsp;</div>
          <div class="que-col-2">
            <div v-if="shouldShowAddABCoption" class="add-opction">
              <div @click="addNewColumnOption(1)" class="circle-icon">
                <v-icon>mdi-plus-circle</v-icon>
                <span>Add Row</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left-que-part">
        <div class="question-title">Column II</div>
        <div v-for="(opt,qindex) in question.options_pqr" :key="qindex" class="que-row">
          <div class="que-col-1">
            <span class="opction-text">{{opt.index}}</span>
          </div>
          <div class="que-col-2">
            <div class="ck-editor">
              <ckeditor
			  :read-only="isEditable"
                :editorUrl="editorURL"
                v-model="opt.option_text"
                :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
              ></ckeditor>
            </div>
          </div>
        </div>
        <div class="que-row add-sl-opction">
          <div class="que-col-1">&nbsp;</div>
          <div class="que-col-2">
            <div v-if="shouldShowAddPQRoption" class="add-opction">
              <div @click="addNewColumnOption(2)" class="circle-icon">
                <v-icon>mdi-plus-circle</v-icon>
                <span>Add Row</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="question-title">Options</div>
    <div class="question-part">
      <div v-for="(opt,opIndex) in question.options" :key="opIndex" class="que-row">
        <div class="que-col-1">
          <span class="opction-text">{{opt.index}}</span>
          <div class="private-radio">
            <input type="radio" @change="onRadioChange(opt)" :checked="isChecked(opt)" color="red" />
            <i
              v-if="isChecked(opt)"
              aria-hidden="true"
              class="v-icon notranslate mdi mdi-radiobox-marked theme--light red--text"
            ></i>
            <i
              v-else
              aria-hidden="true"
              class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
            ></i>
          </div>
        </div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor
			:read-only="isEditable"
              :editorUrl="editorURL"
              v-model="opt.option_text"
              :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="que-row add-sl-opction">
      <div class="que-col-1">&nbsp;</div>
      <div class="que-col-2">
        <div v-if="shouldShowAddoption" class="add-opction">
          <div @click="addNewOption()" class="circle-icon">
            <v-icon>mdi-plus-circle</v-icon>
            <span>Add Option</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="question-title">Hints</div>
        <div v-for="(hint,hi) in question.hints" :key="hi" class="ans-part">
            <div class="que-row">
                <div class="que-col-1">
                    <span class="delete-icon">{{hi+1}}.<v-icon   @click="removeHint" >mdi-delete-circle</v-icon></span>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorUrl"  v-model="hint.text" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="que-row add-sl-opction">
            <div class="que-col-1">&nbsp;</div>
            <div class="que-col-2">
                <div v-if="shouldShowAddHint" @click="addNewHint()" class="add-opction">
                    <div class="circle-icon">
                        <v-icon>mdi-plus-circle</v-icon> 
                        <span>Add Hint</span>
                    </div>
                </div>
            </div>
    </div>-->

    <div class="question-title">Solution</div>
    <div class="ans-part">
      <div class="que-row">
        <div class="que-col-1">&nbsp;</div>
        <div class="que-col-2">
          <div class="ck-editor">
            <ckeditor

			:read-only="isEditable"
              :editorUrl="editorURL"
              v-model="question.solution"
              :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <div class="right-align">
      <v-btn
        @click="onNextQuestion({})" v-if="showNextButton"
        class="right-btn cust-btn"
        color="primary"
      >{{question.btnText}}</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: "MatrixMatchOption",
  props: ['question','onNextQuestion', 'showNextButton','isEditable'],
  data() {
    return {
      questionData:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
    };
  },
  mounted() {
    this.setDefaultData();
  },
  methods: {
    onRadioChange(opt) {
      this.question.options = this.question.options.map(x => {
        if (opt.index === x.index) {
          x.correct_answer = true;
        } else {
          x.correct_answer = false;
        }
        return x;
      });
    },
    // addNewOption() {
    //   this.question.options.push({
    //     index: this.OPTIONS_ABC[this.question.options.length],
    //     option_text: "",
    //     correct_answer: false
    //   });
    // },
    addNewColumnOption(column) {
		if(!this.isEditable){
			if (column === 1) {
					this.question.options_abc.push({
					index: this.OPTIONS_ABC[this.question.options_abc.length],
					option_text: "",
					correct_answer: "",
					column: column
					});
				} else if (column === 2) {
					this.question.options_pqr.push({
					index: this.OPTIONS_PQR[this.question.options_pqr.length],
					option_text: "",
					correct_answer: "",
					column: column
					});
				}
		}
      
    },
    addNewHint() {
      this.question.hints.push({
        text: ""
      });
    },
    removeHint(index) {
      this.question.hints.splice(index, 1);
    },
    setDefaultData() {
      this.question.hints =
        this.question && this.question.hints && this.question.hints.length
          ? this.question.hints
          : [{ text: "" }];
      this.question.options_abc =
        this.question &&
        this.question.options_abc &&
        this.question.options_abc.length
          ? this.question.options_abc
          : [
              {
                index: this.OPTIONS_ABC[0],
                option_text: "",
                column: 1,
                correct_answer: ""
              },
              {
                index: this.OPTIONS_ABC[1],
                option_text: "",
                column: 1,
                correct_answer: ""
              }
            ];
      this.question.options_pqr =
        this.question &&
        this.question.options_pqr &&
        this.question.options_pqr.length
          ? this.question.options_pqr
          : [
              {
                index: this.OPTIONS_PQR[0],
                option_text: "",
                column: 2,
                correct_answer: ""
              },
              {
                index: this.OPTIONS_PQR[1],
                option_text: "",
                column: 2,
                correct_answer: ""
              }
            ];
      this.question.options =
        this.question && this.question.options && this.question.options.length
          ? this.question.options
          : [
              {
                index: this.OPTIONS_ABC[0],
                option_text: "",
                correct_answer: false
              },
              {
                index: this.OPTIONS_ABC[1],
                option_text: "",
                correct_answer: false
              },
              {
                index: this.OPTIONS_ABC[2],
                option_text: "",
                correct_answer: false
              },
              {
                index: this.OPTIONS_ABC[3],
                option_text: "",
                correct_answer: false
              }
            ];
    }
  },
  computed: {
    shouldShowAddABCoption() {
      return this.question.options_abc.length < this.OPTIONS_ABC.length;
    },
    shouldShowAddPQRoption() {
      return this.question.options_pqr.length < this.OPTIONS_PQR.length;
    },
    shouldShowAddoption() {
      return this.question.options.length < this.OPTIONS_ABC.length;
    },
    shouldShowAddHint() {
      return this.question.hints.length < this.OPTIONS_ABC.length;
    }
  },
  watch: {
    question(val) {
      this.setDefaultData();
       document.getElementById('contentItem').scrollIntoView();
    }
  }
};
</script>
